const Steps = Object.freeze({
  Register: '註冊資料',
  Login: '登入資料',
  ForgotPassword: '忘記密碼',
  ResetPassword: '重設密碼',
  ActivateAccount: '驗證帳號',
  Introduction: '投資介紹',
  Calculator: '報酬試算',
  Questions: '常見問題',
  Home: '首頁',
});

export default Steps;
